import {Component, computed, inject, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ProductPriceService} from '@core/services/product-price.service';

@Component({
  selector: 'app-product-custom-badge',
  templateUrl: './product-custom-badge.component.html',
  styleUrls: ['./product-custom-badge.component.scss'],
  imports: [],
})
export class ProductCustomBadgeComponent {
  private sanitizer = inject(DomSanitizer);
  private productPriceService = inject(ProductPriceService);
  
  product = input.required<WineProduct | undefined>();

  // Get the custom badge HTML from the API and bypass security to preserve inline styles
  // Note: This is safe because the HTML comes from our own backend/CMS
  // CustomBadgeHTML is populated from GraphQL API or Algolia (transformed from badge_html)
  customBadgeHTML = computed<SafeHtml | null>(() => {
    const product = this.product();
    let html = product?.customBadgeHTML;
    if (!html) {
      return null;
    }
    
    // Replace {{pct}} placeholder with calculated discount percentage
    const discountPercentage = this.productPriceService.calculateDiscountPercentage(product);
    
    // Only show badge if there's an actual discount
    if (!discountPercentage || discountPercentage <= 0) {
      return null;
    }
    
    html = html.replace(/\{\{pct\}\}/g, discountPercentage.toString());
    
    return this.sanitizer.bypassSecurityTrustHtml(html);
  });
}
